import NotFooterLayout from 'layouts/NotFooterLayout'
import ManageTaxInvoiceRequest from 'components/ManageInvoiceRequest'
import React from 'react'

const ManageTaxInvoiceRequestPage = () => {
  return (
    <NotFooterLayout namePage="จัดการค่าจัดส่ง">
        <div className="layout-content">
            <ManageTaxInvoiceRequest/>
        </div>
    </NotFooterLayout>
  )
}

export default ManageTaxInvoiceRequestPage
